let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("96azZ")).then(() => parcelRequire('j63cY'));